module.exports = __webpack_public_path__ + "static/media/email-black-envelope.1b8fd50e.svg";